export default __webpack_public_path__ + "static/media/team77.a8fa8cf6.JPG";